import { useContext } from 'react';
import SignatureContext from 'common/contexts/SignatureContext';

export default function useSignatureContext() {
  return useContext(SignatureContext);
}
